import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { offscreenFocusable } from '../../../../play-core/styles/accessibility';
import { zIndex } from '../../../../play-core/styles/z-index';
import { usePath } from '../../config/VideoAppContext';
import { useTopicState } from '../../providers/DataProvider/DataContext';
import { PlayPrimaryLink } from '../ClickableComponents/PlayLink';
import { jsx as _jsx } from "react/jsx-runtime";
export const CONTENT_ID = 'content';
export const SkipLink = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(StyledSkipLink, {
    to: `#${CONTENT_ID}`,
    text: t('global.skipToContent')
  });
};

// available on srf & rsi only
const AUDIO_DESCRIPTION_URNS = ['urn:srf:topic:tv:4acf86dd-7ff7-45d3-baf8-33375340d976', 'urn:rsi:topic:tv:90'];
export const AudioDescriptionLink = () => {
  const {
    topics
  } = useTopicState();
  const {
    topicPath
  } = usePath();
  const audioTopicTitle = topics.find(topic => AUDIO_DESCRIPTION_URNS.includes(topic.urn))?.title;
  return audioTopicTitle && /*#__PURE__*/_jsx(StyledSkipLink, {
    to: topicPath(audioTopicTitle),
    text: audioTopicTitle
  });
};
const StyledSkipLink = styled(PlayPrimaryLink).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "AccessibleLink__StyledSkipLink",
  componentId: "sc-kl63i-0"
})(["", " z-index:", ";&:focus{position:fixed;top:12px;left:12px;}"], offscreenFocusable, zIndex.aboveHeader);